import { render, staticRenderFns } from "./Create2.vue?vue&type=template&id=577c5600"
import script from "./Create2.vue?vue&type=script&lang=js"
export * from "./Create2.vue?vue&type=script&lang=js"
import style0 from "./Create2.vue?vue&type=style&index=0&id=577c5600&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('577c5600')) {
      api.createRecord('577c5600', component.options)
    } else {
      api.reload('577c5600', component.options)
    }
    module.hot.accept("./Create2.vue?vue&type=template&id=577c5600", function () {
      api.rerender('577c5600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/cards/Create2.vue"
export default component.exports